import { Controller } from "@hotwired/stimulus"

// One checkbox that ticks every checkbox in a form, and keeps itself honest.
//
// **The form works without this.** Every page has its own checkbox, and the
// submit button reads whatever is ticked, so with JavaScript off a staff member
// can still select pages and submit them. The master checkbox is the
// convenience, and it carries `hidden` in the markup until this controller
// connects, so a control that cannot do anything is never shown. That is the
// opposite of the usual order and it is deliberate: a dead checkbox on a form
// is worse than no checkbox, because the person ticks it and submits nothing.
//
// It also tracks the other direction. A master checkbox that stays ticked after
// somebody unticks a row is lying about what the button will submit, and the
// button is the thing that reaches somebody else's endpoint.
export default class extends Controller {
  // `master` is the input itself and `toggle` is the wrapper that gets shown.
  // Those were one target, on the label around the input, and that was the
  // whole bug: a label has no `checked`, so ticking the box assigned
  // `undefined` to every row and the control over the column did nothing. Read
  // `.checked` off anything but an input and it is always undefined, which is
  // falsy, which looks like "nothing was selected" rather than like a fault.
  static targets = ["toggle", "master", "item", "count"]

  connect() {
    if (this.hasToggleTarget) this.toggleTarget.hidden = false
    this.refresh()
  }

  toggleAll() {
    this.itemTargets.forEach((item) => { item.checked = this.masterTarget.checked })
    this.refresh()
  }

  refresh() {
    const total = this.itemTargets.length
    const checked = this.itemTargets.filter((item) => item.checked).length

    if (this.hasMasterTarget) {
      this.masterTarget.checked = checked === total && total > 0
      // Neither all nor none, so the master is neither: an unticked box above a
      // half-ticked list reads as "nothing is selected", which is wrong.
      this.masterTarget.indeterminate = checked > 0 && checked < total
    }

    if (this.hasCountTarget) {
      this.countTarget.textContent = `${checked} of ${total} selected`
    }
  }
}
